/** ACT004 联动打卡热区（type=22） */

export const ACT004_LINK_CHECKIN_ZONE_TYPE = '22'

export const LINK_CHECKIN_ZONE_SIZE_RPX = 600

export const LINK_CHECKIN_SUCCESS_DURATION_MS_DEFAULT = 500

export const LINK_CHECKIN_SUCCESS_WIDTH_RPX_DEFAULT = 600
export const LINK_CHECKIN_SUCCESS_HEIGHT_RPX_DEFAULT = 600

export function normalizeLinkCheckinPointIndexes(raw) {
  const arr = Array.isArray(raw) ? raw : []
  const out = []
  const seen = new Set()
  arr.forEach((v) => {
    const n = parseInt(v, 10)
    if (!Number.isFinite(n) || n <= 0 || seen.has(n)) return
    seen.add(n)
    out.push(n)
  })
  return out
}

export function normalizeLinkCheckinSuccessDurationMs(raw) {
  const n = parseInt(raw, 10)
  if (!Number.isFinite(n)) return LINK_CHECKIN_SUCCESS_DURATION_MS_DEFAULT
  return Math.max(100, Math.min(10000, n))
}

export function normalizeLinkCheckinSuccessWidthRpx(raw) {
  const n = parseInt(raw, 10)
  if (!Number.isFinite(n)) return LINK_CHECKIN_SUCCESS_WIDTH_RPX_DEFAULT
  return Math.max(80, Math.min(750, n))
}

export function normalizeLinkCheckinSuccessHeightRpx(raw) {
  const n = parseInt(raw, 10)
  if (!Number.isFinite(n)) return LINK_CHECKIN_SUCCESS_HEIGHT_RPX_DEFAULT
  return Math.max(80, Math.min(1200, n))
}

export function pickLinkCheckinZoneFields(source) {
  const s = source && typeof source === 'object' ? source : {}
  return {
    linkCheckinPointIndexes: normalizeLinkCheckinPointIndexes(s.linkCheckinPointIndexes),
    linkCheckinSuccessImg: String(s.linkCheckinSuccessImg || '').trim(),
    linkCheckinSuccessDurationMs: normalizeLinkCheckinSuccessDurationMs(s.linkCheckinSuccessDurationMs),
    linkCheckinSuccessWidthRpx: normalizeLinkCheckinSuccessWidthRpx(s.linkCheckinSuccessWidthRpx),
    linkCheckinSuccessHeightRpx: normalizeLinkCheckinSuccessHeightRpx(s.linkCheckinSuccessHeightRpx)
  }
}

export function isAct004LinkCheckinZoneHotspot(hotspot) {
  return !!(hotspot && String(hotspot.type) === ACT004_LINK_CHECKIN_ZONE_TYPE)
}

/** DOM 唯一 key（须含 pageIndex，避免 visiblePageIndexes 跨页重复 id） */
export function getAct004LinkCheckinZoneKey(hotspot, pageIndex, listIndex) {
  if (!hotspot) return ''
  const pi = Number.isFinite(parseInt(pageIndex, 10)) ? parseInt(pageIndex, 10) : 0
  const li = Number.isFinite(parseInt(listIndex, 10)) ? parseInt(listIndex, 10) : 0
  const idx = parseInt(hotspot.index, 10)
  if (Number.isFinite(idx) && idx > 0) return `p${pi}-idx-${idx}`
  const left = hotspot.left != null ? hotspot.left : ''
  const top = hotspot.top != null ? hotspot.top : ''
  return `p${pi}-i${li}-${left}-${top}`
}
